import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer";
import hrReducer from "./reducer/hr/HrReducer";
import inventoryReducer from "./reducer/inventory/InventoryReducer";
import purchaseReducer from "./reducer/purchase/PurchaseReducer";
import salesReducer from "./reducer/sales/SalesReducer";
import userManagementReducer from "./reducer/user_management/UserManagementReducer";
import dashboardReducer from "./reducer/dashboard/DashboardReducer";

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...hrReducer,
    ...inventoryReducer,
    ...purchaseReducer,
    ...salesReducer,
    ...userManagementReducer,
    ...dashboardReducer,
});

const ERP_Store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default ERP_Store;